import { Component, Input } from '@angular/core';
import { ClipboardService } from '@app/shared/services/clipboard.service';
import { NotifierService } from '@app/shared/services/notifier.service';
import { TranslateService } from '@ngx-translate/core';
import { Profile } from '@app/profile/profile.model';

@Component({
  selector: 'dgx-skill-signal-share-button',
  templateUrl: './skill-signal-share-button.component.html',
  styleUrls: ['./skill-signal-share-button.component.scss'],
})
export class SkillSignalShareButton {
  @Input() public tagId: number;
  @Input() public ownerProfile: Profile;

  public i18n = this.translateService.instant([
    'dgTagRating_ShareTag',
    'ProfileCtrl_ShareSkillSuccess',
  ]);

  constructor(
    private translateService: TranslateService,
    private clipboardService: ClipboardService,
    private notifierService: NotifierService
  ) {}

  public copySkillSignalUrl() {
    const userUrl = this.ownerProfile.vanityUrl;
    let url: string;
    url = `/profile/${userUrl}/`;
    url += `signals?tagId=${this.tagId}`;
    const profileUrl = `${window.location.origin}${url}`;
    this.clipboardService.copyToClipboard(profileUrl);
    this.notifierService.showSuccess(this.i18n.ProfileCtrl_ShareSkillSuccess);
  }
}
